enum Digits {
  MINIMUM = 2,
  MAXIMUM = 2,
}

export default Digits;
